/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { Modal } from 'antd-mobile'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
import { ModalBg } from '@styles/base.style'
import { Button } from '@styles/button.style'
import { CLUB_NOTICE_TYPE } from '@constants/index'
import { Content, MessageWrap, SendBtnStyle, Title } from './index.style'
import { NoticeCommonTag } from '../index.style'


const ClubNoticePopup: React.FC = () => {
  const { globalStore, clubStore } = useRootStore()
  const { visibleClubNoticePopup } = globalStore

  const notice = clubStore.getSelectedNotice()
  const type = notice?.type ?? CLUB_NOTICE_TYPE.NOTICE
  const title = notice?.title ?? ''
  const contents = notice?.contents ?? ''

  const onCloseModal = () => {
    globalStore.setVisibleClubNoticePopup(false)
  }

  let titleClassName = 'club-notice-popup-tit'
  if (type === CLUB_NOTICE_TYPE.EVENT) {
    titleClassName += ' '
    titleClassName += 'event-tit'
  }

  return (
    <Fragment>
      <Modal
        popup
        visible={visibleClubNoticePopup}
        maskClosable={false}
        animated={isMobile}
        animationType="slide-up"
        onClose={onCloseModal}
        className="short-top club-notice-popup"
      >
        <MessageWrap className="club-notice-popup">
          <Title className={titleClassName}>
            {type === CLUB_NOTICE_TYPE.NOTICE && (
              <NoticeCommonTag className="notice-tag">공지사항</NoticeCommonTag>
            )}
            {type === CLUB_NOTICE_TYPE.EVENT && (
              <NoticeCommonTag className="event-tag">이벤트</NoticeCommonTag>
            )}
            {title}
          </Title>
          <Content className="club-notice-popup-content">
            {contents}
          </Content>
        </MessageWrap>
        <Button secondary css={SendBtnStyle} onClick={onCloseModal} className="modal-bottom-btn">
          닫기
        </Button>
        <ModalBg onClick={onCloseModal} />
      </Modal>
    </Fragment>
  )
}

export default observer(ClubNoticePopup)
